import { Component, Input, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { GroupsService } from "../../..";
import { UserService } from "../../../../../shared/services/user.service";
import { ChangeGroupRequest } from "../../../services/ChangeGroupRequest";
import { StudentGroupsTableRefreshService } from "../shared/student-groups-table-refresh.service";
import { UnassignGroupActionsComponent } from "./unassign-group-actions/unassign-group-actions.component";
import * as moment from "moment";

@Component({
	selector: "caass-assigned-table",
	templateUrl: "./assigned-table.component.html",
	styleUrls: ["./assigned-table.component.css"],
})
export class AssignedTableComponent implements OnInit {
	constructor(
		private userService: UserService,
		private AssignedTableService: GroupsService,
		private refreshService: StudentGroupsTableRefreshService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
		this.loadPerson();

		this.subscription = this.refreshService.onRefresh().subscribe((refresh) => {
			refresh.toString(); //
			this.loadPerson();
		});
	}

	ngOnChanges() {
		this.loadPerson();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: Subscription; //Used to update assigned/unassigned students

	@Input() SchoolID: any;
	@Input() SelectedGroup: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedStudents: any = [];
	lstPerson: any = [];

	//Filter lists
	lstHomeroom: any = [];
	lstActiveDesc: any = [];
	lstSchoolFullName: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "LastName", header: "Last Name" },
		{ field: "FirstName", header: "First Name" },
		{ field: "StudentID", header: "Student ID" },
		{ field: "Homeroom", header: "Homeroom" },
		{ field: "SchoolFullName", header: "School" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadPerson() {
		if (this.SelectedGroup == undefined || this.SchoolID == undefined) {
			return;
		}

		this.loading = true;

		var result = this.AssignedTableService.AssignedStudentGetList("", this.SchoolID, this.SelectedGroup.GroupID);
		result.subscribe(
			(response) => {
				this.lstPerson = response;

				for (var i = 0; i < this.lstPerson.length; i++) {
					var next = this.lstPerson[i];

					next.ActiveDesc = next.Active == 1 ? "Yes" : "No";
				}

				//Load Data Filter Lists
				this.lstHomeroom = Array.from(new Set(this.lstPerson.map((item: any) => item.Homeroom))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ActiveDesc))).sort();
				this.lstSchoolFullName = Array.from(new Set(this.lstPerson.map((item: any) => item.SchoolFullName))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadPerson();
	}

	//Custom Button Methods
	onUnassignStudent() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedStudents.length == 0) {
			this.errorMessage = "Select students to unassign";
			return;
		}

		//Get group actions to delete
		var ref = this.dialogService.open(UnassignGroupActionsComponent, {
			header: "Unassign Group Actions",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.SchoolID,
				SelectedGroup: this.SelectedGroup,
			},
		});
		ref.onClose.subscribe((Info) => {
			if (Info != -1) {
				this.FinishUnassign(Info);
			}
		});
	}

	FinishUnassign(Info) {
		//Create Model
		var lstPersonIDs: number[] = [];

		for (var i = 0; i < this.SelectedStudents.length; i++) {
			var next = this.SelectedStudents[i];

			lstPersonIDs = [...lstPersonIDs, next.PersonID];
		}

		let parms: ChangeGroupRequest = {
			GroupID: this.SelectedGroup.GroupID,
			PersonIDs: lstPersonIDs,
			ActionIDs: Info.lstActionInts,
			PointsGroupTransactionIDs: Info.lstPointsGroupTransactionIDs,
		};

		//Call SP
		var result = this.AssignedTableService.GroupUnassignMultiple(parms);
		result.subscribe(
			(response) => {
				if (this.AllClear(response) == true) {
					this.SelectedStudents = [];

					this.loadPerson();

					//TELL ASSIGNED TABLE TO UPDATE
					this.refreshService.refreshChanged(moment(new Date()).format("MM/DD/YYYY HH:mm:ss"));
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "AssignedTable",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Unassign Students",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
	}
	onRowUnselect(val) {
		this.errorMessage = "";
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	AllClear(lstResp) {
		var ans = true;

		for (var z = 0; z < lstResp.length; z++) {
			var next = lstResp[z];

			if (next != "") {
				// Error message found
				ans = false;
				break;
			}
		}

		return ans;
	}

	////////////////////////////////////////////
}
